/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Tax_CodeInputs */

const vi_customer_tax_code = /** @type {(inputs: Customer_Tax_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã số thuế`)
};

/**

* @param {Customer_Tax_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_tax_code = /** @type {((inputs?: Customer_Tax_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Tax_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_tax_code(inputs)
});